<template>
	<modal
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<span v-if="!data">{{ $t('Add Promo Code') }}</span>
			<span v-else>{{ $t('Edit Promo Code') }}</span>
		</template>
		<template slot="body">
			<form @submit.prevent="save">
				<!-- name -->
				<div>
					<div class="form-group">
						<label>{{ $t('Code') }}</label>
						<input @keydown="textKeydown($event)" type="text" name="name" class="form-control" v-model="code" required :class="{'disabled-w-bg': data}">
					</div>
					<!-- promo id -->
					<!-- <div class="form-group select hidden">
					<label class="typo__label">Promo</label>
						<div>
							<multiselect class="select-input" v-model="promoId" tag-placeholder="Add Promo"
								placeholder="Search or add a Promo" label="name" track-by="id"
								:options="promos" :multiple="false" :searchable="true" :show-labels="false">
								<span slot="noResult">Oops! No Promo found.</span>
							</multiselect>
						</div>
					</div> -->
					<!-- user id -->
					<div class="form-group select">
					<label class="typo__label">User</label>
						<div :class="{'disabled-w-bg': data}">
							<multiselect class="select-input" v-model="userId" tag-placeholder="Add User"
								placeholder="Search or add a User" label="name" track-by="id"
								:options="users" :multiple="false" :searchable="true" :show-labels="false">
								<template slot="singleLabel" slot-scope="props">
									<span>{{ props.option.name }}</span>
								</template>
								<template slot="option" slot-scope="props">
									<div class="d-flex justify-content-between"><span>{{ props.option.name }}</span><span>{{ props.option.email }}</span></div>
								</template>
								<span class="arrow-multiselect" slot="caret">
									<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
								</span>
								<span slot="noResult">Oops! No User found.</span>
							</multiselect>
						</div>
					</div>
					<div v-if="!isFetchingPromo">
						<!-- max redemptions -->
						<!-- <div class="form-group disabled">
							<label>{{ $t('Max Redemption') }} (based on the selected promo)</label>
							<input type="number" name="maxRedemption" class="form-control" v-model="maxRedemption" required>
						</div> -->
						<!-- Expired -->
						<!-- <div class="col-md-12 pl-0 pr-0">
							<div class="form-group disabled">
								<label>{{ $t('Expired') }} (based on the selected promo)</label>
								<flat-pickr
									class="date-event form-control"
									:config="configDateTimePicker"
									v-model="expired"
								/>
							</div>
						</div> -->
					</div>
					<label v-if="data" class="text-secondary">You can only edit activate and set as default the code promo</label>
				</div>
				<!-- Is Active -->
				<label class="custom-control custom-checkbox mb-3">
					<input type="checkbox" class="custom-control-input" v-model="isActive">
					<span class="custom-control-label">{{ $t('Active') }}</span>
				</label>
				<!-- Is default -->
				<label class="custom-control custom-checkbox mb-3">
					<input type="checkbox" class="custom-control-input" @change="openConfirmDefault" v-model="isDefault">
					<span class="custom-control-label">{{ $t('Set as default promo') }}</span>
				</label>
				<!-- Submit -->
				<button v-if="!data"
					:disabled="!isFormValid"
					type="submit"
					class="btn btn-submit btn-primary mt-3"
					:class="{ 'is-loading': isSaving }">
					{{ $t('Create Promo Code') }}
				</button>
				<button v-else
					type="submit"
					class="btn btn-submit btn-primary mt-3"
					:class="{ 'is-loading': isSaving }">
					{{ $t('Update Promo Code') }}
				</button>
			</form>
			<!-- Delete Confirmation -->
			<modal
				@close="closeConfirmDefault(isDefault)"
				v-if="isConfirmDefault">
				<template slot="header">
					<h3>{{ $t('Promo code') }}</h3>
				</template>
				<template slot="body">
					<div v-if="isDefault">{{ $t('Are you sure you want to make this promo code ') }} <span class="text-primary">({{ code }})</span> {{ $t('as default promotion on the registration page') }}?</div>
					<div v-if="!isDefault">{{ $t('Are you sure you want to remove this promo code ') }} <span class="text-primary">({{ code }})</span> {{ $t('as default promotion on the registration page') }}?</div>
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							v-if="isDefault"
							class="btn btn-primary"
							@click="acceptConfirmDefault(true)">
							{{ $t('Yes') }}
						</button>
						<button
							v-if="!isDefault"
							class="btn btn-primary"
							@click="acceptConfirmDefault(false)">
							{{ $t('Yes') }}
						</button>
						<button
							class="btn btn-default"
							@click="closeConfirmDefault(isDefault)">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
		</template>
	</modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
// import flatPickr from 'vue-flatpickr-component';
// import 'flatpickr/dist/flatpickr.css';
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import promosCodeApi from '@/api/promoCode';
import promosApi from '@/api/promos';
import usersApi from '@/api/user';

export default {
	name: 'PromoCodesForm',
	props: {
		data: {
			type: Object,
		},
		dataPromo: {
			type: Object,
		},
	},
	components: {
		Modal,
		// flatPickr,
		Multiselect,
	},
	data() {
		return {
			code: '',
			userId: '',
			promoId: '',
			isActive: true,
			isDefault: false,
			isSaving: false,
			// configDateTimePicker: {
			// 	enableTime: false,
			// 	dateFormat: 'Y-m-d',
			// },
			promos: [],
			users: [],
			isFetchingPromo: false,
			isFetchingUsers: false,
			isConfirmDefault: false,
		};
	},
	methods: {
		save() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				const promo = response.data;
				const message = response.message;
				this.$emit('saved', promo);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Promo',
					text: message,
				});
				this.isSaving = false;
				this.$emit('fetch');
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Promo',
					text: message,
				});
				this.isSaving = false;
			};
			if (this.data) {
				promosCodeApi.update(this.data.id, params, callback, errorCallback);
			} else {
				promosCodeApi.create(params, callback, errorCallback);
			}
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
			if (this.data) {
				this.setData(this.data);
			}
		},
		reset() {
			this.code = this.dataPromo.name;
			this.isActive = true;
			this.isDefault = false;
			this.promoId = '';
			this.userId = '';
		},
		setData(data) {
			this.code = data.code;
			this.isActive = data.is_active;
			this.isDefault = data.is_default_promo;
			this.promoId = data.promo_id;
			this.userId = data.user_id;
		},
		fetchPromo() {
			this.isFetchingPromo = true;
			const callback = (response) => {
				const items = response.data;
				this.promos = items;
				if (this.data) {
					const index = this.promos.findIndex(({ id }) => id === this.data.promo_id);
					this.promoId = this.promos[index];
				}
				this.isFetchingPromo = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Promos',
					text: message,
				});
				this.isFetchingPromo = false;
			};
			const params = {
				page: 1,
				limit: 1000,
			};
			promosApi.getList(params, callback, errorCallback);
		},
		fetchUsers() {
			this.isFetchingUsers = true;
			const callback = (response) => {
				const items = response.data;
				this.users = items;
				this.isFetchingUsers = false;
				if (this.data) {
					const index = this.users.findIndex(({ id }) => id === this.data.user_id);
					this.userId = this.users[index];
				}
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isFetchingUsers = false;
			};
			const params = {
				page: 1,
				limit: 9999,
			};
			usersApi.getUsers(params, callback, errorCallback);
		},
		textKeydown(e) {
			if (/[^A-Z0-9]/gi.test(e.key)) {
				e.preventDefault();
			}
		},
		openConfirmDefault() {
			this.isConfirmDefault = true;
		},
		acceptConfirmDefault(status) {
			this.isConfirmDefault = false;
			this.isDefault = status;
		},
		closeConfirmDefault(status) {
			this.isConfirmDefault = false;
			this.isDefault = !status;
		},
	},
	computed: {
		params() {
			const user = this.userId ? this.userId : '';
			const params = {
				code: this.code,
				is_active: this.isActive,
				is_default_promo: this.isDefault,
				user_id: user && user.id ? user.id : '',
			};
			if (this.dataPromo) params.promo_id = this.dataPromo.id && this.dataPromo.id ? this.dataPromo.id : '';
			return params;
		},
		isFormValid() {
			return (
				this.code !== ''
				&& this.maxRedemption !== -1
			);
		},
		maxRedemption() {
			return this.dataPromo && this.dataPromo.max_redemptions ? this.dataPromo.max_redemptions : 0;
		},
		expired() {
			return this.dataPromo && this.dataPromo.expired_at ? this.dataPromo.expired_at : '';
		},
	},
	created() {
		this.initData();
		this.fetchPromo();
		this.fetchUsers();
	},
};
</script>
